import { createContext, useContext, useMemo, useState } from 'react';
import { usePresupuestosActivos } from '../hooks/usePresupuestosActivos';

const PresupuestoContext = createContext(null);

function toId(valor) {
  if (valor === undefined || valor === null || valor === '') return null;
  const numero = Number(valor);
  return Number.isFinite(numero) ? numero : null;
}

export function PresupuestoProvider({ children }) {
  const { items, isLoading, error, recargar } = usePresupuestosActivos();
  const [cdPresupuestoSeleccionado, setCdPresupuestoSeleccionado] = useState(null);

  const seleccionarPresupuesto = (valor) => {
    setCdPresupuestoSeleccionado(toId(valor));
  };

  const valor = useMemo(
    () => ({
      presupuestosActivos: items,
      isLoading,
      error,
      cdPresupuestoSeleccionado,
      seleccionarPresupuesto,
      recargar,
    }),
    [items, isLoading, error, cdPresupuestoSeleccionado, recargar],
  );

  return <PresupuestoContext.Provider value={valor}>{children}</PresupuestoContext.Provider>;
}

export function usePresupuesto() {
  const contexto = useContext(PresupuestoContext);
  if (!contexto) {
    throw new Error('usePresupuesto debe usarse dentro de un PresupuestoProvider');
  }
  return contexto;
}
